const eventName = 'popup:toggle';
const className = 'popup-open';

document.body.addEventListener(eventName, (event) => {
    if (event.value) document.body.classList.add(className);
    else document.body.classList.remove(className);
}, false);

export function updatePopupStateInBody (value) {
    if (typeof value !== "boolean") value = !document.body.classList.contains(className);
    document.body.dispatchEvent(new CustomEvent(eventName, { value: value }));
}
